import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Empresa, PagareCSV, PagarePDF } from 'app/models/pagare.model';
import { Plantilla } from 'app/models/plantilla.model';
import { PagareService } from 'app/services/pagare.service';
import { take, Subscription } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { Router } from '@angular/router';
import { PdfService } from 'app/services/pdf.service';

@Component({
    selector: 'pagares',
    templateUrl: './pagares.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./pagares.component.scss'],
})
export class PagaresComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    fileUploadPlaceholder: string =
        '<p class="filepond--text-action">Arrastre el archivo a esta área o <span class="filepond--label-action"> haz click aquí </span></p><p class="filepond--text-action-secondary">Máximo 5 MB - Formato CSV</p>';

    fileCsv: {
        file: File | string;
        fileext: string;
        filename: string;
        filetype: string;
        status: boolean;
    };

    fileUploading: boolean = false;
    table = 'oculto';

    modeloOpciones: {
        PLANTILLA: Plantilla[];
    } = {
        PLANTILLA: [],
    };

    plantillaSelected: string = '';

    uploadProgress: number;
    uploadSub: Subscription;

    displayedColumns: string[] = [
        'select',
        'RUTDV',
        'CUENTA_FINANCIERA',
        'IMEIPCS',
        'RAZON_SOCIAL',
        'MONTO_TOTAL',
        'FECHA_VENCIMIENTO_PAGARE',
        'NRO_CONTRATO',
        'FECHA_FIRMA_CONTRATO',
        'FECHA_VERIFICACION_DE_PAGO',
    ];

    dataSource: MatTableDataSource<PagareCSV>;
    selection = new SelectionModel<PagareCSV>(true, []);
    deletingRows: boolean = false;
    showModalPreview: boolean = false;
    modalEliminar: boolean = false;
    infoEmpresa: Empresa;
    arrPagares: PagarePDF[] = null;
    showModalLoading = 'oculto';
    errorMessage: string = '';
    idProcesoPdf: string = null;
    loadingPrint: boolean = false;
    numPagaresGenerados: number = 0;
    constructor(private route: Router, private _pagare: PagareService, private _pdf: PdfService) {
        this._pagare
            .listarPlantillas()
            .pipe(take(1))
            .subscribe({
                next: (plantillas) => {
                    this.modeloOpciones.PLANTILLA = plantillas;
                },
                error: (err) => {
                    console.log(err);
                    this.modeloOpciones.PLANTILLA = [];
                },
                complete: () => {
                    let optDefaultPlantilla: Plantilla = {
                        ID: null,
                        TIPO: null,
                        NOMBRE: null,
                        VALOR: '',
                        ACTIVO: null,
                    };
                    this.modeloOpciones.PLANTILLA.unshift(optDefaultPlantilla);
                },
            });
    }

    generateCarpetas(): void {
        if (this.selection.selected.length > 0 && this.plantillaSelected != '') {
            this.showModalLoading = 'loading';
            let id_carga = this.selection.selected[0].ID_CARGA;
            let arrIdsLectura = this.selection.selected.map((m) => m.ID_LECTURA);
            this.numPagaresGenerados = arrIdsLectura.length;
            console.log('paso 1');
            this._pagare
                .creaCarpetas(this.plantillaSelected, id_carga, arrIdsLectura)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.idProcesoPdf = data.idProceso;
                        this.generaPdfProceso(data.idProceso);
                    },
                    error: (err) => {
                        console.log(err.status);
                        if (err.status == 409) {
                            this.showModalLoading = 'error';
                            this.idProcesoPdf = null;
                            this.errorMessage =
                                'No hay folios disponibles para generar el(los) pagaré(s), por favor agregue folios para retomar la operación.';
                        } else {
                            this.showModalLoading = 'error';
                            this.idProcesoPdf = null;
                            this.errorMessage = 'Error en generar carpeta';
                        }
                    },
                    complete: () => {},
                });
        }
        // setTimeout(() => {
        //     this.showModalLoading = 'mostrar';
        // }, 2000);
    }

    private generaPdfProceso(ID_PROCESO: string): void {
        console.log('paso 2');

        this._pdf
            .generaPdfProceso(ID_PROCESO)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.splitPdfProceso(ID_PROCESO);
                },
                error: (err) => {
                    this.showModalLoading = 'error';
                    this.idProcesoPdf = null;
                    this.errorMessage = 'Error en generar pdf proceso';
                },
                complete: () => {},
            });
    }

    private splitPdfProceso(ID_PROCESO: string): void {
        console.log('paso 3');

        this._pdf
            .splitPdfProceso(ID_PROCESO)
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    console.log('printPdfProceso ok');

                    this.showModalLoading = 'mostrar';
                    //AQUI
                },
                error: (err) => {
                    this.showModalLoading = 'error';
                    this.idProcesoPdf = null;
                    this.errorMessage = 'Error en separacion pdfs';
                },
                complete: () => {},
            });
    }

    modalPreview(): void {
        if (this.selection.selected.length > 0 && this.plantillaSelected != '') {
            this.arrPagares = this.selection.selected.map((pagare) => {
                return {
                    FOLIO: null,
                    RAZON_SOCIAL: pagare.RAZON_SOCIAL,
                    RUTDV: pagare.RUTDV,
                    RUT: pagare.RUT,
                    DV: pagare.DV,
                    MONTO_TOTAL: pagare.MONTO_TOTAL,
                    FECHA_CONTRATO: pagare.FECHA_FIRMA_CONTRATO,
                    NRO_CONTRATO: pagare.NRO_CONTRATO,
                    DIRECCION: pagare.DIRECCION_LEGAL,
                    COMUNA: pagare.COMUNA_DIRECCION_LEGAL,
                    CIUDAD: pagare.CIUDAD_DIRECCION_LEGAL,
                    MONTO_TOTAL_PALABRAS: pagare.MONTO_TOTAL_PALABRAS,
                    FECHA_CREACION: new Date(),
                    EMP_NOMBRE: this.infoEmpresa.NOMBRE, //"CLARO CHILE S.A.",
                    EMP_RUT: this.infoEmpresa.RUT, //"96.799.250-K",
                    EMP_DIRECCION: this.infoEmpresa.DIRECCION, //"Avenida El Salto 5450",
                    EMP_COMUNA: this.infoEmpresa.COMUNA, //"Huechuraba",
                    EMP_CIUDAD: this.infoEmpresa.CIUDAD, //"Santiago",
                    EMP_REPRESENTANTE_LEGAL: this.infoEmpresa.REPRESENTANTE_LEGAL, //"Cecilia Camus Godoy",
                    EMP_FECHA_ESCRITURA_PUBLICA: this.infoEmpresa.FECHA_ESCRITURA_PUBLICA, // new Date("2022-01-12"),
                };
            });

            this.showModalPreview = true;
        }
    }

    closeModalPreview(): void {
        this.showModalPreview = false;
    }

    modalPagare(): void {
        this.showModalLoading = 'pagare';
    }

    imprimirPagares(): void {
        if (this.idProcesoPdf) {
            this.loadingPrint = true;

            this._pdf.obtenerPdfProceso(this.idProcesoPdf).subscribe({
                next: (data: any) => {
                    console.log('printPdfProceso ok');
                    this._pdf.printFn(data.body, 'pdf');
                    this.loadingPrint = false;
                },
                error: (e: any) => {
                    console.log('printPdfProceso err');
                    this.loadingPrint = false;
                },
                complete: () => {},
            });
        }
    }

    modalOculto(): void {
        this.numPagaresGenerados = 0;
        this.showModalLoading = 'oculto';
        this.route.navigateByUrl('home/judicial');
    }
    goback(): void {
        this.route.navigateByUrl('home');
    }

    // dataSource2: any[] = [];
    // foods: Food[] = [
    // 	{ value: '1', viewValue: 'Seleccione Platilla' },
    // 	{ value: '2', viewValue: 'Platilla 1' },
    // 	{ value: '3', viewValue: 'Platilla 2' }
    // ]

    get totalMonto() {
        return this.selection.selected.reduce((prev, item) => prev + item.MONTO_TOTAL, 0);
    }

    ngOnInit() {}

    /**
        Función para eliminar del dataSource los elementos seleccionados.
    */
    borrarSeleccionados() {
        // console.log('dataSource', this.dataSource.data)
        // console.log('Seleccionados', this.selection.selected)
        this.deletingRows = true;
        if (this.selection.selected.length > 0) {
            let id_carga = this.selection.selected[0].ID_CARGA;
            let arrIdsLectura = this.selection.selected.map((m) => m.ID_LECTURA);
            this._pagare
                .deleteFromCsv(id_carga, arrIdsLectura)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.dataSource.data = this.dataSource.data.filter((f) => !this.selection.selected.some((s) => s.ID_LECTURA == f.ID_LECTURA));
                        this.selection = new SelectionModel<PagareCSV>(true, []);
                        this.dataSource._updateChangeSubscription();
                        this.deletingRows = false;
                    },
                    error: (err) => {
                        console.log(err);
                        this.deletingRows = false;
                    },
                    complete: () => {},
                });
        }
        this.modalEliminar = false;
    }

    /**
        Función  para ver detalle
    */
    onTableAction(row: any) {
        // console.log('ver detalles de', row)
    }

    /* Funciones de selección */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.filter((f) => f.GESTIONABLE == 1).length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => (row.GESTIONABLE == 1 ? this.selection.select(row) : null));
    }

    /* Carga correcta del sort */
    // ngAfterViewInit() {
    // 	this.dataSource.sort = this.sort
    // }

    setFileInfo($event: any) {
        console.log($event);
        this.fileCsv = $event;
        if ($event.status) {
            this.subirArchivo();
        }
    }

    subirArchivo() {
        this.fileUploading = true;
        this.table = 'loading';
        console.log(this.fileCsv);
        const upload$ = this._pagare.subirCsv(this.fileCsv.file);
        this.uploadSub = upload$.subscribe({
            next: (event) => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.uploadProgress = Math.round(100 * (event.loaded / event.total));
                }
                if (event.type === HttpEventType.Response) {
                    this.fileUploading = false;
                    this.table = 'mostrar';
                    if (event.body) {
                        console.log('donwload completed');

                        this.dataSource = new MatTableDataSource<PagareCSV>(event.body);
                        this.dataSource.paginator = this.paginator;
                        this.selection = new SelectionModel<PagareCSV>(true, []);
                        this.dataSource.sort = this.sort;
                        this.obtenerInfoEmpresa();
                    } else {
                        console.log('error completed');
                        this.table = 'error';
                    }
                }
            },
            error: (err) => {
                console.log(err);
                this.table = 'error';
            },
            complete: () => {},
        });
    }

    obtenerInfoEmpresa() {
        if (!this.infoEmpresa) {
            this._pagare
                .companyInfo()
                .pipe(take(1))
                .subscribe({
                    next: (empresa) => {
                        this.infoEmpresa = empresa;
                    },
                    error: (err) => {
                        console.log(err);
                    },
                    complete: () => {},
                });
        }
    }

    hasItem(pagare: PagareCSV) {
        return this.selection.selected.some(({ ID_LECTURA }) => {
            return ID_LECTURA === pagare.ID_LECTURA;
        });
    }

    handleClick(pagare: PagareCSV): void {
        let payload: PagareCSV[] = [];

        const checked = this.selection.selected.some(({ ID_LECTURA }) => {
            return ID_LECTURA === pagare.ID_LECTURA;
        });

        if (!checked) {
            payload = [...this.selection.selected, pagare];
        } else {
            payload = this.selection.selected.filter(({ ID_LECTURA }) => ID_LECTURA !== pagare.ID_LECTURA);
        }

        this.selection = new SelectionModel<PagareCSV>(true, [...payload]);
    }
    closeModalCrear() {
        this.showModalLoading = 'oculto';
        //this.modalModel = null;
    }
}
